import { render, staticRenderFns } from "./CoBookingResourcesList.vue?vue&type=template&id=372c939c&"
import script from "./CoBookingResourcesList.vue?vue&type=script&lang=ts&"
export * from "./CoBookingResourcesList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports